// Module
var code = "<template> <require from=\"app/core/components/tasks/task\"></require> <div class=\"row\"> <div class=\"col s12\"> <task task-binding.bind=\"taskBinding\" task-display.bind=\"taskDisplay\" label-key=\"cm:carePlanIntervention.$\"></task> </div> </div> </template> ";
// Exports
module.exports = code;